import { Container, Typography, CircularProgress } from '@mui/material'
import { useEffect, useRef, useState } from "react";
import { getComponent } from "../../services/ComponentServices";
import { Divider } from 'ui-neumorphism';
import './Visualizador.css';

interface VisualizadorProps {
    type: number
    datas?: any
}

const Visualizador = ({ type, datas }: VisualizadorProps) => {

    const [data, setData] = useState<any | null>(null)
    const [loading, setloading] = useState(true);
    const [iframeLoading, setIframeLoading] = useState(true);
    const [iframeError, setIframeError] = useState(false);
    const timeoutRef = useRef<number | null>(null);

    useEffect(() => {
        window.scroll(0, 0)

        const obtenerData = async () => {
            setloading(true);
            try {
                const response = await getComponent(type, 2);
                setData(response.data[0]);
                setloading(false);
            } catch (error) {
                setloading(false);
            }
        };
        obtenerData();

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);

    useEffect(() => {
        if (!loading && data?.image) {
            timeoutRef.current = window.setTimeout(() => {
                setIframeLoading(false);
                setIframeError(true);
            }, 10000);
        }
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [loading, data]);

    if (loading || !data) {
        return (
            <Container sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <CircularProgress />
            </Container>
        );
    }

    if (!data.image) {
        return (
            <Container sx={{ height: '100%', marginTop: 2 }}>
                <Typography variant="h4" color="#001933">{data.componenttype?.name}</Typography>
                <Divider />
                <Typography variant="body1" sx={{ mt: 4, textAlign: 'center' }} color="text.secondary">
                    No hay ningún archivo disponible para mostrar.
                </Typography>
            </Container>
        );
    }

    const pdfUrl = data.image;
    const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(pdfUrl)}&embedded=true`;

    return (
        <Container sx={{ height: '100%', marginTop: 2 }}>
            <div style={{ margin: 2 }}>
                <Typography variant="h4" color="#001933">{data.componenttype.name}</Typography>
                <Divider />
                <div className="pdf-container">
                    <p>
                        <strong>Fecha de última actualización:</strong> {data.createdate}
                    </p>
                    {iframeError ? (
                        <Container sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                            <Typography variant="body1" color="text.secondary" textAlign="center">
                                No se pudo cargar el visor.{' '}
                                <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                                    Ábrelo aquí
                                </a>
                            </Typography>
                        </Container>
                    ) : (
                        <>
                            {iframeLoading && (
                                <Container sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                                    <CircularProgress />
                                </Container>
                            )}
                            <iframe
                                src={viewerUrl}
                                width="100%"
                                height="900px"
                                style={{ border: 'none', display: iframeLoading ? 'none' : 'block' }}
                                title="PDF Viewer"
                                onLoad={() => {
                                    if (timeoutRef.current) clearTimeout(timeoutRef.current);
                                    setIframeLoading(false);
                                }}
                            />
                        </>
                    )}
                </div>
            </div>
        </Container>
    );
}

export default Visualizador;